<template>
  <Breadcrumbs />
  <DynamicContent
    id="category-overview-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  ></DynamicContent>

  <CategoriesGrid :title="$t('categories.title')" class="mb-4" />

  <DynamicContent
    id="category-overview-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  ></DynamicContent>
  <DynamicContent
    id="category-overview-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  ></DynamicContent>
  <DynamicContent
    id="category-overview-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  ></DynamicContent>
</template>

<script setup lang="ts">
import { useWebsitePageQuery } from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/categorieen/",
    fr: "/categories/",
    nl: "/categorieen/",
  },
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);
</script>
